export const SET_PLACES = 'SET_PLACES';
export const PLACE_SELECTED = 'PLACE_SELECTED';
export const ERROR_SELECTING = 'ERROR_SELECTING';